(function () {
  function initNewsletter(section) {
    if (!section || section.dataset.slrNewsletterInitialized === 'true') return;
    section.dataset.slrNewsletterInitialized = 'true';

    var cards = Array.prototype.slice.call(section.querySelectorAll('.slr-newsletter__guide-card'));
    var selectedBox = section.querySelector('[data-selected-guide-box]');
    var selectedTitle = section.querySelector('[data-selected-guide-title]');
    var tagsInput = section.querySelector('[data-newsletter-tags]');
    var formbox = section.querySelector('[data-newsletter-formbox]');
    var submitButton = section.querySelector('[data-newsletter-submit]');
    var form = section.querySelector('form');

    var selectedTag = '';
    var selectedGuideTitle = '';

    function buildPostedSuccessHtml() {
      return ''
        + '<div class="slr-newsletter__posted-success">'
        + '  <div class="slr-newsletter__posted-badge">Vielen Dank</div>'
        + '  <h2 class="slr-newsletter__posted-title">Bitte bestätigen Sie jetzt Ihre E-Mail-Adresse</h2>'
        + '  <p class="slr-newsletter__posted-text">Wir haben Ihnen gerade eine Bestätigungs-E-Mail geschickt.</p>'
        + '  <p class="slr-newsletter__posted-text">Öffnen Sie bitte Ihr E-Mail-Postfach und klicken Sie in dieser E-Mail auf den Bestätigungslink.</p>'
        + '  <p class="slr-newsletter__posted-text">Danach erhalten Sie den ausgewählten kostenlosen Ratgeber automatisch per E-Mail. Das dauert normalerweise nur wenige Sekunden.</p>'
        + '  <div class="slr-newsletter__posted-note">Falls Sie keine E-Mail sehen, prüfen Sie bitte auch den Spam-Ordner oder den Werbung-Ordner.</div>'
        + '</div>';
    }

    function renderPostedSuccessState() {
      var isPosted =
        window.location.href.indexOf('customer_posted=true') !== -1 ||
        section.querySelector('.slr-newsletter__posted-success');

      if (!isPosted || !formbox) return false;

      formbox.classList.remove('is-locked');
      formbox.classList.add('is-posted');

      if (!formbox.querySelector('.slr-newsletter__posted-success')) {
        formbox.innerHTML = buildPostedSuccessHtml();
      }

      return true;
    }

    if (renderPostedSuccessState()) {
      return;
    }

    function normalizeTags(baseTags, guideTag) {
      var tags = (baseTags || '')
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);

      tags = tags.filter(function (tag) {
        return tag.indexOf('gratis-ratgeber-') !== 0;
      });

      if (guideTag) {
        tags.push(guideTag);
      }

      return tags.join(', ');
    }

    function selectGuide(card) {
      selectedTag = card.getAttribute('data-guide-tag') || '';
      selectedGuideTitle = card.getAttribute('data-guide-title') || '';

      cards.forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      card.classList.add('is-active');
      card.setAttribute('aria-pressed', 'true');

      if (selectedBox && selectedTitle) {
        selectedTitle.textContent = 'AUSGEWÄHLT: ' + selectedGuideTitle.toLocaleUpperCase('de-DE');
        selectedBox.classList.add('is-visible');
      }

      if (tagsInput) {
        var baseTags = tagsInput.getAttribute('data-base-tags') || '';
        tagsInput.value = normalizeTags(baseTags, selectedTag);
      }

      if (formbox) {
        formbox.classList.remove('is-locked');
      }

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('disabled');
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectGuide(card);
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!selectedTag) {
          event.preventDefault();

          if (formbox) {
            formbox.classList.add('is-locked');
            formbox.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }
      });
    }
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-slr-newsletter-section]').forEach(initNewsletter); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();
